import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {setAnimationDOMRects, setAvatarMuted, setCurrentSentenceUID, setReady} from "../store/reducers/questionReducer";
import {cleanStringForAvatar, isAccentureTwin} from "../helpers/util";
import davidAvatarImage from "../assets/images/david-avatarimg.png";
import willKnightAvatarImage from "../assets/images/willknight-avatarimg.png";
import willKnightPosterImage from "../assets/images/will-knight-poster.jpg";
import allisonHornAvatarImage from "../assets/images/allisonhorn-avatarimg.jpg";
import allisonHornPosterImage from "../assets/images/allison-horn-poster.jpg";
import edoAvatarImage from "../assets/images/edosegal-avatarimage.jpg"
import edoSegalPosterImage from "../assets/images/edo-segal-poster.jpg";
import paulGoldingPosterImage from "../assets/images/paul-golding-poster.jpg";
import nicolasBarattePosterImage from "../assets/images/nicolas-baratte-poster.jpg";
import cherryMaPosterImage from "../assets/images/cherryma-poster.jpg";
import smithCodioPosterImage from "../assets/images/smithcodio-poster.jpg";
import frederickHavemeyerPosterImage from "../assets/images/frederick-havemeyer-poster.jpg";
import paulGoldingAvatarImage from "../assets/images/paul-golding-avatarimg.jpg";
import nicolasBaratteAvatarImage from "../assets/images/nicolas-baratte-avatarimg.jpg";
import cherryMaAvatarImage from "../assets/images/cherryma-avatarimg.jpg";
import smithCodioAvatarImage from "../assets/images/smithcodio-avatarimg.jpg";
import frederickHavemeyerAvatarImage from "../assets/images/frederick-havemeyer-avatarimg.jpg";
import rajivChandranAvatarImage from "../assets/images/rajivchandran-avatarimg.jpg";
import rajivChandranPosterImage from "../assets/images/rajivchandran-poster.jpg";
import jonGordonPosterImage from "../assets/images/jongordon-poster.jpg";
import jonGordonAvatarImage from "../assets/images/jongordon-avatarimg.jpg";
import liorLavidPosterImage from "../assets/images/liorlavid-poster.jpg";
import liorLavidAvatarImage from "../assets/images/liorlavid-avatarimg.jpg";
import danaKochAvatarImage from "../assets/images/danakoch-avatarimg.jpg";
import johnGoodyerAvatarImage from "../assets/images/johngoodyer-avatarimg.jpg";
import simonHollandAvatarImage from "../assets/images/simonholland-avatarimg.jpg";
import jessMajekodunmiAvatarImage from "../assets/images/jessmajekodunmi-avatarimg.jpg";
import danaKochPosterImage from "../assets/images/danakoch-poster.jpg";
import johnGoodyerPosterImage from "../assets/images/johngoodyer-poster.jpg";
import simonHollandPosterImage from "../assets/images/simonholland-poster.jpg";
import jessMajekodunmiPosterImage from "../assets/images/jessmajekodunmi-poster.jpg";
import philipMoyerAvatarImage from "../assets/images/philipmoyer-avatarimg.jpg";
import philipMoyerPosterImage from "../assets/images/philipmoyer-poster.jpg";
import reidHoffmanAvatarImage from "../assets/images/reidhoffman-avatarimg.jpg";
import reidHoffmanPosterImage from "../assets/images/reidhoffman-poster.jpg";
import drCamilleKandikoHowsonAvatarImage from "../assets/images/drcamillekandikohowson-avatarimg.jpg";
import drCamilleKandikoHowsonPosterImage from "../assets/images/drcamillekandikohowson-poster.jpg";
import kathyChenAvatarImage from "../assets/images/kathychen-avatarimg.jpg";
import kathyChenPosterImage from "../assets/images/kathychen-poster.jpg";
import tierneyMorganAvatarImage from "../assets/images/tierneymorgan-avatarimg.jpg";
import tierneyMorganPosterImage from "../assets/images/tierneymorgan-poster.jpg";
import bobGerardAvatarImage from "../assets/images/bobgerard-avatarimg.jpg";
import bobGerardPosterImage from "../assets/images/bobgerard-poster.jpg";

import ethanLawsonAvatarImage from "../assets/images/ethan-lawson.png";
import ethanLawsonPosterImage from "../assets/images/ethan-lawson.png";
import sophiaMartinezAvatarImage from "../assets/images/sophia-martinez.png";
import sophiaMartinezPosterImage from "../assets/images/sophia-martinez.png";
import edoSegalAvatarImage from "../assets/images/edosegal-avatarimage.jpg";

import johnSamuelAvatarImage from "../assets/images/john-samuel.png";
import johnSamuelPosterImage from "../assets/images/john-samuel.png";

import isabellaWongAvatarImage from "../assets/images/isabella-wong.png";
import isabellaWongPosterImage from "../assets/images/isabella-wong.png";

import susanGoodyerAvatarImage from "../assets/images/susangoodyer-avatarimg.jpg";
import susanGoodyerPosterImage from "../assets/images/susangoodyer-poster.jpg";

import bartClarysseAvatarImage from "../assets/images/bart-clarysse-avatarimg.jpg";
import bartClaryssePosterImage from "../assets/images/bart-clarysse-poster.jpg";

import omarMerloAvatarImage from "../assets/images/omar-merlo-avatarimg.jpg";
import omarMerloPosterImage from "../assets/images/omar-merlo-poster.jpg";

import markKennedyAvatarImage from "../assets/images/mark-kennedy-avatarimg.jpg";
import markKennedyPosterImage from "../assets/images/mark-kennedy-poster.jpg";


interface IProps {
    stream: any;
    sendDataToSocket: (data: any) => void;
    loading?: boolean,
    enterExperience?: () => void
}

export const Stream = (props: IProps) => {
    const {
        stream,
        sendDataToSocket,
        enterExperience,
        loading
    } = props;
    const dispatch = useDispatch();

    const video = React.useRef<HTMLVideoElement | any>(null)
    const [welcomePlayed, setWelcomePlayed] = React.useState<boolean>(false);
    const [muted, setMuted] = React.useState<boolean>(false);
    const ready = useSelector((state: any) => state.questionReducer.ready);
    const streamData = useSelector((state: any) => state.questionReducer.streamData);
    const streamDataRef = React.useRef(streamData);
    const streamRef = React.useRef(stream);
    const answerState = useSelector((state: any) => state.questionReducer.answer);
    const welcome = useSelector((state: any) => state.questionReducer.welcome);
    const showExperience = useSelector((state: any) => state.questionReducer.showExperience);
    const avatarId = useSelector((state: any) => state.questionReducer.avatarId);
    const profilePath = useSelector((state: any) => state.questionReducer.profilePath);
    const welcomeVideoPlay = useSelector((state: any) => state.questionReducer.welcomeVideoPlay);
    const avatarMuted = useSelector((state: any) => state.questionReducer.avatarMuted);
    const summaryToTalk = useSelector((state: any) => state.questionReducer.summaryToTalk);
    const firstName = useSelector((state: any) => state.questionReducer.firstName);
    const dataChannel = useSelector((state: any) => state.questionReducer.dataChannel);
    const sessionId = useSelector((state: any) => state.questionReducer.sessionId);

    const audio = React.useRef<HTMLAudioElement | any>(null)

    const divRef: any = React.createRef();

    let image: any = (window as any).avatarImage ? (window as any).avatarImage : edoAvatarImage;
    if (profilePath === 'david' || profilePath === 'david-shrier') {
        image = davidAvatarImage;
    }
    if (profilePath === 'will-knight') {
        image = willKnightAvatarImage;
    }
    if (profilePath === 'allisonhorn') {
        image = allisonHornAvatarImage;
    }
    if (profilePath === 'paulgolding') {
        image = paulGoldingAvatarImage;
    }
    if (profilePath === 'nicolasbaratte') {
        image = nicolasBaratteAvatarImage;
    }
    if (profilePath === 'cherryma') {
        image = cherryMaAvatarImage;
    }
    if (profilePath === 'frederickhavemeyer') {
        image = frederickHavemeyerAvatarImage;
    }
    if (profilePath === 'rajivchandran') {
        image = rajivChandranAvatarImage;
    }
    if (profilePath === 'smithcodio') {
        image = smithCodioAvatarImage;
    }
    if (profilePath === 'jongordon') {
        image = jonGordonAvatarImage;
    }
    if (profilePath === 'liorlavid') {
        image = liorLavidAvatarImage;
    }
    if (profilePath === 'danakoch') {
        image = danaKochAvatarImage;
    }
    if (profilePath === 'johngoodyer') {
        image = johnGoodyerAvatarImage;
    }
    if (profilePath === 'simonholland') {
        image = simonHollandAvatarImage;
    }
    if (profilePath === 'jessmajekodunmi') {
        image = jessMajekodunmiAvatarImage;
    }
    if (profilePath === 'philipmoyer') {
        image = philipMoyerAvatarImage;
    }
    if (profilePath === 'reidhoffman') {
        image = reidHoffmanAvatarImage;
    }
    if (profilePath === 'drcamillekandikohowson') {
        image = drCamilleKandikoHowsonAvatarImage;
    }
    if (profilePath === 'kathychen') {
        image = kathyChenAvatarImage;
    }
    if (profilePath === 'tierneymorgan') {
        image = tierneyMorganAvatarImage;
    }
    if (profilePath === 'bobgerard') {
        image = bobGerardAvatarImage;
    }

    if (profilePath === 'edosegal') {
        image = edoSegalAvatarImage;
    }

    if (profilePath === 'john-samuel') {
        image = johnSamuelAvatarImage;
    }

    if (profilePath === 'isabella-wong') {
        image = isabellaWongAvatarImage;
    }

    if (profilePath === 'sophia-martinez') {
        image = sophiaMartinezAvatarImage;
    }

    if (profilePath === 'ethan-lawson') {
        image = ethanLawsonAvatarImage;
    }

    if (profilePath === 'susangoodyer') {
        image = susanGoodyerAvatarImage;
    }

    if (profilePath === 'bartclarysse') {
        image = bartClarysseAvatarImage;
    }

    if (profilePath === 'omarmerlo') {
        image = omarMerloAvatarImage;
    }

    if (profilePath === 'markkennedy') {
        image = markKennedyAvatarImage;
    }

    React.useEffect(() => {
        streamRef.current = stream;
    }, [stream])

    React.useEffect(() => {
        streamDataRef.current = streamData;
    }, [streamData])

    React.useEffect(() => {
        (async () => {
            if (!welcomePlayed && welcome && welcome !== '' && stream.streamUrl !== '' && ready === true && showExperience === true) {
                //await createAnswerStream(answerState);
                await startTalk(welcome, 'welcome')
                setWelcomePlayed(true);
            }
        })();

        return () => {
        };
    }, [welcome, stream.streamUrl, ready, showExperience, welcomePlayed])

    React.useEffect(() => {
        (async () => {
            if (summaryToTalk && summaryToTalk !== '' && stream.streamUrl !== '' && ready === true && showExperience === true) {
                try {
                    await stopStream()
                } catch (e) {
                }
                //await createAnswerStream(answerState);
                await startTalk(summaryToTalk, 'summaryToTalk')
                setWelcomePlayed(true);
            }
        })();

        return () => {
        };
    }, [summaryToTalk, stream.streamUrl, ready, showExperience, welcomePlayed])

    React.useEffect(() => {
        (async () => {
            if (answerState && answerState.answer) {
                try {
                    await stopStream()
                } catch (e) {
                }

                //await createAnswerStream(answerState);
                await startTalk(answerState.answer, answerState.question_uid)
            }
        })();

        return () => {
        };
    }, [answerState])


    React.useEffect(() => {
        if (stream.streamUrl !== '' && stream.streamUrl) {
            loadPlaylist(stream.streamUrl, stream.audioStreamUrl)
        }
    }, [stream.streamUrl])

    React.useEffect(() => {
        if (stream.streamUrl !== '') {
            const data: any = divRef.current.getBoundingClientRect();
            let image: any = (window as any).avatarImage ? (window as any).avatarImage : edoAvatarImage;
            if (profilePath === 'david' || profilePath === 'david-shrier') {
                image = davidAvatarImage;
            }
            if (profilePath === 'will-knight') {
                image = willKnightAvatarImage;
            }
            if (profilePath === 'allisonhorn') {
                image = allisonHornAvatarImage;
            }
            data['key'] = Math.random();
            data['image'] = image;
            dispatch(setAnimationDOMRects(data));
        }
    }, [stream.streamUrl, showExperience])

    React.useEffect(() => {
        video.current.muted = avatarMuted;
        audio.current.muted = avatarMuted;

    }, [avatarMuted])
    React.useEffect(() => {
        video.current.muted = muted;
        audio.current.muted = muted;
    }, [muted])
    const muteAvatar = () => {
        setMuted(!muted);
    }

    function loadPlaylist(streamUrl: string, audioStreamUrl: string) {
        if (video.current !== null) {
            video.current.srcObject = streamUrl;
            video.current.removeEventListener('canplay', playAction);
            video.current.addEventListener('canplay', playAction);
            audio.current.srcObject = audioStreamUrl;
        }
    }

    function playAction() {
        dispatch(setReady(true));
    }

    async function stopStream() {
        if (window.chatOnly) {
            return;
        }
        let data = {
            type: "cancel",
            data: {
                sessionId: sessionId,
            },
        };
        console.log('stop', data);
        dataChannel.send(JSON.stringify(data));
    }


    async function startTalk(answer: string, uid: string) {
        if (window.chatOnly) {
            return;
        }
        let answerCleaned = cleanStringForAvatar(answer)
        video.current.muted = false;
        video.current.play();
        audio.current.muted = false;
        audio.current.play();
        dispatch(setCurrentSentenceUID(uid))
        let data = {
            type: "talk",
            data: {
                talkId: uid,
                sessionId: sessionId,
                text: answerCleaned,
            },
        };
        console.log('sending', data);
        dataChannel.send(JSON.stringify(data));
        dispatch(setAvatarMuted(false));
    }


    const page = (window as any).page ? (window as any).page : 'profile';
    let posterImage = '';
    if (profilePath === 'will-knight') {
        posterImage = willKnightPosterImage;
    }
    if (profilePath === 'allisonhorn') {
        posterImage = allisonHornPosterImage;
    }
    if (profilePath === 'edo-segal') {
        posterImage = edoSegalPosterImage;
    }
    if (profilePath === 'paulgolding') {
        posterImage = paulGoldingPosterImage;
    }
    if (profilePath === 'nicolasbaratte') {
        posterImage = nicolasBarattePosterImage;
    }
    if (profilePath === 'cherryma') {
        posterImage = cherryMaPosterImage;
    }
    if (profilePath === 'frederickhavemeyer') {
        posterImage = frederickHavemeyerPosterImage;
    }
    if (profilePath === 'rajivchandran') {
        posterImage = rajivChandranPosterImage;
    }
    if (profilePath === 'smithcodio') {
        posterImage = smithCodioPosterImage;
    }
    if (profilePath === 'jongordon') {
        posterImage = jonGordonPosterImage;
    }
    if (profilePath === 'liorlavid') {
        posterImage = liorLavidPosterImage;
    }
    if (profilePath === 'danakoch') {
        posterImage = danaKochPosterImage;
    }
    if (profilePath === 'johngoodyer') {
        posterImage = johnGoodyerPosterImage;
    }
    if (profilePath === 'simonholland') {
        posterImage = simonHollandPosterImage;
    }
    if (profilePath === 'jessmajekodunmi') {
        posterImage = jessMajekodunmiPosterImage;
    }
    if (profilePath === 'philipmoyer') {
        posterImage = philipMoyerPosterImage;
    }
    if (profilePath === 'reidhoffman') {
        posterImage = reidHoffmanPosterImage;
    }
    if (profilePath === 'drcamillekandikohowson') {
        posterImage = drCamilleKandikoHowsonPosterImage;
    }
    if (profilePath === 'kathychen') {
        posterImage = kathyChenPosterImage;
    }
    if (profilePath === 'tierneymorgan') {
        posterImage = tierneyMorganPosterImage;
    }
    if (profilePath === 'bobgerard') {
        posterImage = bobGerardPosterImage;
    }

    if (profilePath === 'edosegal') {
        posterImage = edoSegalPosterImage;
    }

    if (profilePath === 'john-samuel') {
        posterImage = johnSamuelPosterImage;
    }

    if (profilePath === 'isabella-wong') {
        posterImage = isabellaWongPosterImage;
    }

    if (profilePath === 'sophia-martinez') {
        posterImage = sophiaMartinezPosterImage;
    }

    if (profilePath === 'ethan-lawson') {
        posterImage = ethanLawsonPosterImage;
    }

    if (profilePath === 'susangoodyer') {
        posterImage = susanGoodyerPosterImage;
    }

    if (profilePath === 'bartclarysse') {
        posterImage = bartClaryssePosterImage;
    }

    if (profilePath === 'omarmerlo') {
        posterImage = omarMerloPosterImage;
    }

    if (profilePath === 'markkennedy') {
        posterImage = markKennedyPosterImage;
    }

    return (
        <div className={(showExperience) ? 'tc-chat-avatar-wrapper fade-in-text' : 'launch tc-chat-avatar-wrapper'}>
            {!window.chatOnly &&
                <div
                    className={`${((welcomeVideoPlay)) ? 'tc-moved-avatar tc-avatar-video-wrapper' : 'tc-avatar-video-wrapper '}`}
                    ref={divRef} id='stream-video-wrapper'>
                    {/* <div className="tc-stream-vol-btn vol-up">
                        <svg
                            className="tc-stream-vol-up"
                            fill="#000000"
                            width="20px"
                            height="20px"
                            viewBox="-3.5 0 32 32"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M13.16 25.46c-0.16 0-0.28-0.040-0.4-0.12l-7.52-4.32h-2.6c-1.44 0-2.64-1.16-2.64-2.6v-4.8c0-1.44 1.2-2.64 2.64-2.64h2.6l7.52-4.32c0.12-0.080 0.28-0.12 0.4-0.12 1.44 0 2.64 1.2 2.64 2.64v13.6c0 1.48-1.16 2.68-2.64 2.68zM2.64 12.66c-0.52 0-0.96 0.44-0.96 0.96v4.8c0 0.52 0.44 0.96 0.96 0.96h2.84c0.16 0 0.28 0.040 0.4 0.12l7.48 4.28c0.44-0.080 0.76-0.48 0.76-0.92v-13.64c0-0.48-0.32-0.84-0.76-0.92l-7.48 4.28c-0.12 0.080-0.28 0.12-0.4 0.12l-2.84-0.040zM18.64 21.297c-0.16 0-0.32-0.040-0.48-0.16-0.4-0.24-0.48-0.8-0.24-1.16 0.8-1.16 1.2-2.52 1.2-3.92 0-1.44-0.44-2.84-1.28-4.040-0.28-0.36-0.16-0.92 0.2-1.16 0.36-0.28 0.92-0.16 1.16 0.2 1.040 1.48 1.56 3.2 1.56 5 0 1.76-0.52 3.44-1.48 4.88-0.080 0.24-0.36 0.36-0.64 0.36zM22.28 23.042c-0.16 0-0.28-0.040-0.44-0.12-0.4-0.24-0.52-0.76-0.28-1.16 1.040-1.72 1.6-3.72 1.6-5.76s-0.56-4.040-1.6-5.76c-0.24-0.4-0.12-0.92 0.28-1.16s0.92-0.12 1.16 0.28c1.2 2 1.84 4.28 1.84 6.64s-0.64 4.64-1.84 6.64c-0.16 0.24-0.44 0.4-0.72 0.4z" />
                        </svg>

                        <svg
                            className="tc-stream-vol-mute"
                            fill="#000000"
                            width="20px"
                            height="20px"
                            viewBox="-8 0 32 32"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M13.96 7.641l0.84-1.4c0.24-0.44 0.12-0.96-0.32-1.24-0.44-0.24-0.96-0.12-1.24 0.32l-1.84 3.080-6.16 3.52h-2.6c-1.44 0-2.64 1.2-2.64 2.64v4.76c0 1.44 1.2 2.64 2.64 2.64h0.64l-2.28 3.8c-0.24 0.44-0.12 0.96 0.32 1.24 0.16 0.080 0.32 0.12 0.44 0.12 0.32 0 0.6-0.16 0.76-0.44l2.8-4.64 7.36 4.24c0.12 0.080 0.28 0.12 0.4 0.12 1.44 0 2.64-1.2 2.64-2.64v-13.6c0.080-1.2-0.72-2.2-1.76-2.52zM2.6 20.281c-0.52 0-0.96-0.44-0.96-0.96v-4.76c0-0.52 0.44-0.96 0.96-0.96h2.88c0.16 0 0.28-0.040 0.4-0.12l3.76-2.16-5.36 8.96h-1.68zM14.12 23.761c0 0.48-0.32 0.84-0.76 0.92l-7.16-4.080 6.6-11.080 0.56-0.32c0.44 0.080 0.76 0.48 0.76 0.92v13.64z" />
                        </svg>
                    </div>*/}
                    {loading && <div className="tc-loading-container">
                        <div className="tc-loading-spinner">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>}
                    {/* <video src="https://demoassets.touchcast.com/ai-chat/avatars/idle_v8.mp4" muted autoPlay></video> */}
                    <div className='tc-mute-control' onClick={muteAvatar}>
                        {muted ? <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16 9.50009L21 14.5001M21 9.50009L16 14.5001M4.6 9.00009H5.5012C6.05213 9.00009 6.32759 9.00009 6.58285 8.93141C6.80903 8.87056 7.02275 8.77046 7.21429 8.63566C7.43047 8.48353 7.60681 8.27191 7.95951 7.84868L10.5854 4.69758C11.0211 4.17476 11.2389 3.91335 11.4292 3.88614C11.594 3.86258 11.7597 3.92258 11.8712 4.04617C12 4.18889 12 4.52917 12 5.20973V18.7904C12 19.471 12 19.8113 11.8712 19.954C11.7597 20.0776 11.594 20.1376 11.4292 20.114C11.239 20.0868 11.0211 19.8254 10.5854 19.3026L7.95951 16.1515C7.60681 15.7283 7.43047 15.5166 7.21429 15.3645C7.02275 15.2297 6.80903 15.1296 6.58285 15.0688C6.32759 15.0001 6.05213 15.0001 5.5012 15.0001H4.6C4.03995 15.0001 3.75992 15.0001 3.54601 14.8911C3.35785 14.7952 3.20487 14.6422 3.10899 14.4541C3 14.2402 3 13.9601 3 13.4001V10.6001C3 10.04 3 9.76001 3.10899 9.54609C3.20487 9.35793 3.35785 9.20495 3.54601 9.10908C3.75992 9.00009 4.03995 9.00009 4.6 9.00009Z"
                                    stroke="#ffffff" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg> :
                            <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M16.0004 9.00009C16.6281 9.83575 17 10.8745 17 12.0001C17 13.1257 16.6281 14.1644 16.0004 15.0001M18 5.29177C19.8412 6.93973 21 9.33459 21 12.0001C21 14.6656 19.8412 17.0604 18 18.7084M4.6 9.00009H5.5012C6.05213 9.00009 6.32759 9.00009 6.58285 8.93141C6.80903 8.87056 7.02275 8.77046 7.21429 8.63566C7.43047 8.48353 7.60681 8.27191 7.95951 7.84868L10.5854 4.69758C11.0211 4.17476 11.2389 3.91335 11.4292 3.88614C11.594 3.86258 11.7597 3.92258 11.8712 4.04617C12 4.18889 12 4.52917 12 5.20973V18.7904C12 19.471 12 19.8113 11.8712 19.954C11.7597 20.0776 11.594 20.1376 11.4292 20.114C11.239 20.0868 11.0211 19.8254 10.5854 19.3026L7.95951 16.1515C7.60681 15.7283 7.43047 15.5166 7.21429 15.3645C7.02275 15.2297 6.80903 15.1296 6.58285 15.0688C6.32759 15.0001 6.05213 15.0001 5.5012 15.0001H4.6C4.03995 15.0001 3.75992 15.0001 3.54601 14.8911C3.35785 14.7952 3.20487 14.6422 3.10899 14.4541C3 14.2402 3 13.9601 3 13.4001V10.6001C3 10.04 3 9.76001 3.10899 9.54609C3.20487 9.35793 3.35785 9.20495 3.54601 9.10908C3.75992 9.00009 4.03995 9.00009 4.6 9.00009Z"
                                    stroke="#ffffff" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        }
                    </div>
                    <video
                        className={`${((welcomeVideoPlay)) ? 'dnone' : ''}`}
                        poster={posterImage}
                        autoPlay
                        muted={true} ref={video} playsInline={true} webkit-playsinline="true"></video>
                    <audio
                        autoPlay
                        muted={true} ref={audio} playsInline={true} webkit-playsinline="true"></audio>
                    {/* <!-- <div className="tc-chat-avatar-volume muted">
                    <a href="#">
                        <svg className="tc-vol-muted" width="30px" height="30px" fill="#000000"  viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="M575.536 65.904c-10.432-5.552-23.087-4.928-32.911 1.696L221.52 319.712l-106.624.08c-54.512 0-98.88 38.657-98.88 86.4l1.712 211.137c0 47.536 44.352 86.224 98.863 86.224l106.592.065L542.576 956.37a31.977 31.977 0 0 0 17.905 5.472c5.152 0 10.32-1.249 15.008-3.745a31.951 31.951 0 0 0 17.008-28.256V94.16a32.044 32.044 0 0 0-16.96-28.257zm-47.039 803.728l-277.6-224.526a31.97 31.97 0 0 0-17.889-5.473l-116.384-.064c-20.544 0-34.88-11.712-34.88-22.464l-1.727-211.152c0-10.48 14.336-22.16 34.895-22.16l116.4-.08a32.017 32.017 0 0 0 17.856-5.457l279.328-224v715.376zm365.505-357.118l104.593-105.84c12.496-12.496 12.496-32.752 0-45.248-12.464-12.496-32.752-12.496-45.248 0L849.011 466.994 744.675 361.426c-12.464-12.496-32.752-12.496-45.248 0s-12.496 32.752 0 45.248l104.592 105.84-103.6 104.816c-12.464 12.48-12.496 32.753 0 45.249s32.784 12.496 45.28 0l103.312-104.544 103.312 104.544c12.496 12.496 32.752 12.496 45.248 0s12.496-32.769 0-45.249z"/></svg>

                        <svg className="tc-vol-unmuted" width="30px" height="30px" fill="#000000" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="M574.496 65.904c-10.432-5.552-23.087-4.928-32.911 1.696L220.497 319.712l-106.624.08c-54.512 0-98.88 38.657-98.88 86.4l1.712 211.137c0 47.536 44.352 86.224 98.863 86.224l106.592.065L541.552 956.37a31.977 31.977 0 0 0 17.905 5.472c5.152 0 10.32-1.249 15.008-3.745a31.951 31.951 0 0 0 17.008-28.256V94.16a32.026 32.026 0 0 0-16.977-28.257zm-47.023 803.728L249.874 645.106a31.97 31.97 0 0 0-17.889-5.473l-116.384-.064c-20.544 0-34.88-11.712-34.88-22.464L79.01 405.953c0-10.48 14.336-22.16 34.896-22.16l116.4-.08a32.017 32.017 0 0 0 17.855-5.457l279.312-224v715.376zm320.993-352.126c0-85.008-58.433-156.433-138.913-169.873-17.712-2.928-33.935 8.864-36.848 26.305-2.912 17.424 8.88 33.92 26.288 36.832 50.32 8.4 85.473 52.304 85.473 106.753 0 51.84-36.368 96.687-86.496 106.688-17.344 3.44-28.592 20.288-25.12 37.631 3.024 15.216 16.368 25.745 31.344 25.745 2.064 0 4.192-.193 6.288-.624 79.952-15.936 137.984-87.216 137.984-169.456zm-42.465-293.601c-16.528-6.16-35.01 2.241-41.153 18.8-6.193 16.56 2.223 34.992 18.783 41.168 96.528 36.015 161.376 129.903 161.376 233.63 0 103.777-64.848 197.842-161.312 234.002-16.56 6.223-24.944 24.655-18.751 41.183 4.816 12.88 17.009 20.785 29.969 20.785a31.97 31.97 0 0 0 11.215-2.033c121.344-45.504 202.88-163.632 202.88-293.936s-81.6-248.288-203.007-293.599z"/></svg>
                    </a>

                </div> --> */}
                </div>
            }
            <div
                className={`tc-chat-avatar-details  ${(welcomeVideoPlay) ? 'fade-out-div' : 'fade-in-div'} ${(profilePath === 'david' || profilePath === 'david-shrier') ? 'david-bio' : ''}`}>
                <div className="tc-chat-avatar-name">{(window as any).name}</div>
                <div className="tc-chat-avatar-designation">{(window as any).role}</div>
                {(profilePath === 'david' || profilePath === 'david-shrier') &&
                    <div className='tc-extra-items-container'>
                        <div className="tc-chat-avatar-description">Imperial College</div>
                        <div className='tc-chat-extra-item'>
                            <a href='https://tc.touchcast.com/s/yyf0eorw2t' target='_blank'><img
                                src={`${process.env.PUBLIC_URL}/assets/images/playvideo.png`} alt="Watch"
                                id="img-watch-btn"/><span className='tc-chat-extra-item-text'>Watch Unit 4</span></a>
                        </div>
                        <div className='tc-chat-extra-item'>
                            <a href="https://demoassets.touchcast.com/profile-assets/David/Unit-Slides.pdf"
                               download={true}><img
                                src={`${process.env.PUBLIC_URL}/assets/images/download-pdf.png`} alt="Download"
                                id="img-download-btn"/><span
                                className='tc-chat-extra-item-text'>Download Unit 4 Slides</span></a>
                        </div>
                    </div>}
                {enterExperience && !loading && ready &&
                    <div className='launch-btn-container'>
                        <a href="#" className="tc-launch-enter-btn" onClick={enterExperience}>Chat
                            with {firstName}</a>
                    </div>
                }

            </div>
            {isAccentureTwin(profilePath) && !showExperience &&
                <div className={"twin-disclaimer"}>
                    This is an innovation asset designed to help T&O practitioners explore the use of GenerativeAI for
                    Talent solutions. Ciscape is a Touchcast product. Touchcast is an Accenture Project Spotlight
                    partner.
                    For more information on exploring Touchcast, please reach out to <a
                    href={"mailto: Rachel.L.Filderman@accenture.com"}>Rachel.L.Filderman@accenture.com</a>.
                </div>
            }
        </div>
    );
}
